export default [
    {
        id: 1,
        name_ca: 'Bo',
        name_en: 'Good',
        name_es: 'Bueno'
    },
    {
        id: 1,
        name_ca: 'Mig',
        name_en: 'Average',
        name_es: 'Medio'
    },
    {
        id: 1,
        name_ca: 'Escàs',
        name_en: 'Poor',
        name_es: 'Escaso'
    },
    {
        id: 1,
        name_ca: 'Inexistent',
        name_en: 'Inexisting',
        name_es: 'Inexistente'
    }
]


// WEBPACK FOOTER //
// ./src/options/level_options.js